/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedTrafficIndexRouteImport } from './routes/_authenticated/traffic/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSecurityIndexRouteImport } from './routes/_authenticated/security/index'
import { Route as AuthenticatedPromotionsIndexRouteImport } from './routes/_authenticated/promotions/index'
import { Route as AuthenticatedProductsIndexRouteImport } from './routes/_authenticated/products/index'
import { Route as AuthenticatedNotificationsIndexRouteImport } from './routes/_authenticated/notifications/index'
import { Route as AuthenticatedLanguagesIndexRouteImport } from './routes/_authenticated/languages/index'
import { Route as AuthenticatedApisIndexRouteImport } from './routes/_authenticated/apis/index'
import { Route as AuthenticatedActivityIndexRouteImport } from './routes/_authenticated/activity/index'
import { Route as AuthenticatedPromotionsCreateIndexRouteImport } from './routes/_authenticated/promotions/create/index'
import { Route as AuthenticatedProductsOrdersIndexRouteImport } from './routes/_authenticated/products/orders/index'
import { Route as AuthenticatedProductsGuidesIndexRouteImport } from './routes/_authenticated/products/guides/index'
import { Route as AuthenticatedProductsCreateIndexRouteImport } from './routes/_authenticated/products/create/index'
import { Route as AuthenticatedProductsCategoriesIndexRouteImport } from './routes/_authenticated/products/categories/index'
import { Route as AuthenticatedActivityLogsIndexRouteImport } from './routes/_authenticated/activity/logs/index'
import { Route as AuthenticatedActivityDepositHistoryIndexRouteImport } from './routes/_authenticated/activity/deposit-history/index'
import { Route as AuthenticatedActivityBalanceChangesIndexRouteImport } from './routes/_authenticated/activity/balance-changes/index'
import { Route as AuthenticatedPromotionsUpdatePromotionIdRouteImport } from './routes/_authenticated/promotions/update/$promotionId'
import { Route as AuthenticatedProductsUpdateProductIdRouteImport } from './routes/_authenticated/products/update/$productId'
import { Route as AuthenticatedProductsGuidesCreateIndexRouteImport } from './routes/_authenticated/products/guides/create/index'
import { Route as AuthenticatedProductsGuidesUpdateGuideIdRouteImport } from './routes/_authenticated/products/guides/update/$guideId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTrafficIndexRoute =
  AuthenticatedTrafficIndexRouteImport.update({
    id: '/traffic/',
    path: '/traffic/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSecurityIndexRoute =
  AuthenticatedSecurityIndexRouteImport.update({
    id: '/security/',
    path: '/security/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPromotionsIndexRoute =
  AuthenticatedPromotionsIndexRouteImport.update({
    id: '/promotions/',
    path: '/promotions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsIndexRoute =
  AuthenticatedProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsIndexRoute =
  AuthenticatedNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLanguagesIndexRoute =
  AuthenticatedLanguagesIndexRouteImport.update({
    id: '/languages/',
    path: '/languages/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApisIndexRoute = AuthenticatedApisIndexRouteImport.update({
  id: '/apis/',
  path: '/apis/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedActivityIndexRoute =
  AuthenticatedActivityIndexRouteImport.update({
    id: '/activity/',
    path: '/activity/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPromotionsCreateIndexRoute =
  AuthenticatedPromotionsCreateIndexRouteImport.update({
    id: '/promotions/create/',
    path: '/promotions/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsOrdersIndexRoute =
  AuthenticatedProductsOrdersIndexRouteImport.update({
    id: '/products/orders/',
    path: '/products/orders/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsGuidesIndexRoute =
  AuthenticatedProductsGuidesIndexRouteImport.update({
    id: '/products/guides/',
    path: '/products/guides/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsCreateIndexRoute =
  AuthenticatedProductsCreateIndexRouteImport.update({
    id: '/products/create/',
    path: '/products/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsCategoriesIndexRoute =
  AuthenticatedProductsCategoriesIndexRouteImport.update({
    id: '/products/categories/',
    path: '/products/categories/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedActivityLogsIndexRoute =
  AuthenticatedActivityLogsIndexRouteImport.update({
    id: '/activity/logs/',
    path: '/activity/logs/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedActivityDepositHistoryIndexRoute =
  AuthenticatedActivityDepositHistoryIndexRouteImport.update({
    id: '/activity/deposit-history/',
    path: '/activity/deposit-history/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedActivityBalanceChangesIndexRoute =
  AuthenticatedActivityBalanceChangesIndexRouteImport.update({
    id: '/activity/balance-changes/',
    path: '/activity/balance-changes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPromotionsUpdatePromotionIdRoute =
  AuthenticatedPromotionsUpdatePromotionIdRouteImport.update({
    id: '/promotions/update/$promotionId',
    path: '/promotions/update/$promotionId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsUpdateProductIdRoute =
  AuthenticatedProductsUpdateProductIdRouteImport.update({
    id: '/products/update/$productId',
    path: '/products/update/$productId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsGuidesCreateIndexRoute =
  AuthenticatedProductsGuidesCreateIndexRouteImport.update({
    id: '/products/guides/create/',
    path: '/products/guides/create/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProductsGuidesUpdateGuideIdRoute =
  AuthenticatedProductsGuidesUpdateGuideIdRouteImport.update({
    id: '/products/guides/update/$guideId',
    path: '/products/guides/update/$guideId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/': typeof AuthenticatedIndexRoute
  '/activity': typeof AuthenticatedActivityIndexRoute
  '/apis': typeof AuthenticatedApisIndexRoute
  '/languages': typeof AuthenticatedLanguagesIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/products': typeof AuthenticatedProductsIndexRoute
  '/promotions': typeof AuthenticatedPromotionsIndexRoute
  '/security': typeof AuthenticatedSecurityIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/traffic': typeof AuthenticatedTrafficIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/products/update/$productId': typeof AuthenticatedProductsUpdateProductIdRoute
  '/promotions/update/$promotionId': typeof AuthenticatedPromotionsUpdatePromotionIdRoute
  '/activity/balance-changes': typeof AuthenticatedActivityBalanceChangesIndexRoute
  '/activity/deposit-history': typeof AuthenticatedActivityDepositHistoryIndexRoute
  '/activity/logs': typeof AuthenticatedActivityLogsIndexRoute
  '/products/categories': typeof AuthenticatedProductsCategoriesIndexRoute
  '/products/create': typeof AuthenticatedProductsCreateIndexRoute
  '/products/guides': typeof AuthenticatedProductsGuidesIndexRoute
  '/products/orders': typeof AuthenticatedProductsOrdersIndexRoute
  '/promotions/create': typeof AuthenticatedPromotionsCreateIndexRoute
  '/products/guides/update/$guideId': typeof AuthenticatedProductsGuidesUpdateGuideIdRoute
  '/products/guides/create': typeof AuthenticatedProductsGuidesCreateIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/': typeof AuthenticatedIndexRoute
  '/activity': typeof AuthenticatedActivityIndexRoute
  '/apis': typeof AuthenticatedApisIndexRoute
  '/languages': typeof AuthenticatedLanguagesIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/products': typeof AuthenticatedProductsIndexRoute
  '/promotions': typeof AuthenticatedPromotionsIndexRoute
  '/security': typeof AuthenticatedSecurityIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/traffic': typeof AuthenticatedTrafficIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/products/update/$productId': typeof AuthenticatedProductsUpdateProductIdRoute
  '/promotions/update/$promotionId': typeof AuthenticatedPromotionsUpdatePromotionIdRoute
  '/activity/balance-changes': typeof AuthenticatedActivityBalanceChangesIndexRoute
  '/activity/deposit-history': typeof AuthenticatedActivityDepositHistoryIndexRoute
  '/activity/logs': typeof AuthenticatedActivityLogsIndexRoute
  '/products/categories': typeof AuthenticatedProductsCategoriesIndexRoute
  '/products/create': typeof AuthenticatedProductsCreateIndexRoute
  '/products/guides': typeof AuthenticatedProductsGuidesIndexRoute
  '/products/orders': typeof AuthenticatedProductsOrdersIndexRoute
  '/promotions/create': typeof AuthenticatedPromotionsCreateIndexRoute
  '/products/guides/update/$guideId': typeof AuthenticatedProductsGuidesUpdateGuideIdRoute
  '/products/guides/create': typeof AuthenticatedProductsGuidesCreateIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/activity/': typeof AuthenticatedActivityIndexRoute
  '/_authenticated/apis/': typeof AuthenticatedApisIndexRoute
  '/_authenticated/languages/': typeof AuthenticatedLanguagesIndexRoute
  '/_authenticated/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/_authenticated/products/': typeof AuthenticatedProductsIndexRoute
  '/_authenticated/promotions/': typeof AuthenticatedPromotionsIndexRoute
  '/_authenticated/security/': typeof AuthenticatedSecurityIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/traffic/': typeof AuthenticatedTrafficIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/products/update/$productId': typeof AuthenticatedProductsUpdateProductIdRoute
  '/_authenticated/promotions/update/$promotionId': typeof AuthenticatedPromotionsUpdatePromotionIdRoute
  '/_authenticated/activity/balance-changes/': typeof AuthenticatedActivityBalanceChangesIndexRoute
  '/_authenticated/activity/deposit-history/': typeof AuthenticatedActivityDepositHistoryIndexRoute
  '/_authenticated/activity/logs/': typeof AuthenticatedActivityLogsIndexRoute
  '/_authenticated/products/categories/': typeof AuthenticatedProductsCategoriesIndexRoute
  '/_authenticated/products/create/': typeof AuthenticatedProductsCreateIndexRoute
  '/_authenticated/products/guides/': typeof AuthenticatedProductsGuidesIndexRoute
  '/_authenticated/products/orders/': typeof AuthenticatedProductsOrdersIndexRoute
  '/_authenticated/promotions/create/': typeof AuthenticatedPromotionsCreateIndexRoute
  '/_authenticated/products/guides/update/$guideId': typeof AuthenticatedProductsGuidesUpdateGuideIdRoute
  '/_authenticated/products/guides/create/': typeof AuthenticatedProductsGuidesCreateIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/forgot-password'
    | '/login'
    | '/'
    | '/activity'
    | '/apis'
    | '/languages'
    | '/notifications'
    | '/products'
    | '/promotions'
    | '/security'
    | '/settings'
    | '/traffic'
    | '/users'
    | '/products/update/$productId'
    | '/promotions/update/$promotionId'
    | '/activity/balance-changes'
    | '/activity/deposit-history'
    | '/activity/logs'
    | '/products/categories'
    | '/products/create'
    | '/products/guides'
    | '/products/orders'
    | '/promotions/create'
    | '/products/guides/update/$guideId'
    | '/products/guides/create'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/'
    | '/activity'
    | '/apis'
    | '/languages'
    | '/notifications'
    | '/products'
    | '/promotions'
    | '/security'
    | '/settings'
    | '/traffic'
    | '/users'
    | '/products/update/$productId'
    | '/promotions/update/$promotionId'
    | '/activity/balance-changes'
    | '/activity/deposit-history'
    | '/activity/logs'
    | '/products/categories'
    | '/products/create'
    | '/products/guides'
    | '/products/orders'
    | '/promotions/create'
    | '/products/guides/update/$guideId'
    | '/products/guides/create'
  id:
    | '__root__'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/_authenticated/'
    | '/_authenticated/activity/'
    | '/_authenticated/apis/'
    | '/_authenticated/languages/'
    | '/_authenticated/notifications/'
    | '/_authenticated/products/'
    | '/_authenticated/promotions/'
    | '/_authenticated/security/'
    | '/_authenticated/settings/'
    | '/_authenticated/traffic/'
    | '/_authenticated/users/'
    | '/_authenticated/products/update/$productId'
    | '/_authenticated/promotions/update/$promotionId'
    | '/_authenticated/activity/balance-changes/'
    | '/_authenticated/activity/deposit-history/'
    | '/_authenticated/activity/logs/'
    | '/_authenticated/products/categories/'
    | '/_authenticated/products/create/'
    | '/_authenticated/products/guides/'
    | '/_authenticated/products/orders/'
    | '/_authenticated/promotions/create/'
    | '/_authenticated/products/guides/update/$guideId'
    | '/_authenticated/products/guides/create/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/traffic/': {
      id: '/_authenticated/traffic/'
      path: '/traffic'
      fullPath: '/traffic'
      preLoaderRoute: typeof AuthenticatedTrafficIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/security/': {
      id: '/_authenticated/security/'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof AuthenticatedSecurityIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/promotions/': {
      id: '/_authenticated/promotions/'
      path: '/promotions'
      fullPath: '/promotions'
      preLoaderRoute: typeof AuthenticatedPromotionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/': {
      id: '/_authenticated/products/'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AuthenticatedProductsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications/': {
      id: '/_authenticated/notifications/'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/languages/': {
      id: '/_authenticated/languages/'
      path: '/languages'
      fullPath: '/languages'
      preLoaderRoute: typeof AuthenticatedLanguagesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/apis/': {
      id: '/_authenticated/apis/'
      path: '/apis'
      fullPath: '/apis'
      preLoaderRoute: typeof AuthenticatedApisIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity/': {
      id: '/_authenticated/activity/'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AuthenticatedActivityIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/promotions/create/': {
      id: '/_authenticated/promotions/create/'
      path: '/promotions/create'
      fullPath: '/promotions/create'
      preLoaderRoute: typeof AuthenticatedPromotionsCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/orders/': {
      id: '/_authenticated/products/orders/'
      path: '/products/orders'
      fullPath: '/products/orders'
      preLoaderRoute: typeof AuthenticatedProductsOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/guides/': {
      id: '/_authenticated/products/guides/'
      path: '/products/guides'
      fullPath: '/products/guides'
      preLoaderRoute: typeof AuthenticatedProductsGuidesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/create/': {
      id: '/_authenticated/products/create/'
      path: '/products/create'
      fullPath: '/products/create'
      preLoaderRoute: typeof AuthenticatedProductsCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/categories/': {
      id: '/_authenticated/products/categories/'
      path: '/products/categories'
      fullPath: '/products/categories'
      preLoaderRoute: typeof AuthenticatedProductsCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity/logs/': {
      id: '/_authenticated/activity/logs/'
      path: '/activity/logs'
      fullPath: '/activity/logs'
      preLoaderRoute: typeof AuthenticatedActivityLogsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity/deposit-history/': {
      id: '/_authenticated/activity/deposit-history/'
      path: '/activity/deposit-history'
      fullPath: '/activity/deposit-history'
      preLoaderRoute: typeof AuthenticatedActivityDepositHistoryIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/activity/balance-changes/': {
      id: '/_authenticated/activity/balance-changes/'
      path: '/activity/balance-changes'
      fullPath: '/activity/balance-changes'
      preLoaderRoute: typeof AuthenticatedActivityBalanceChangesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/promotions/update/$promotionId': {
      id: '/_authenticated/promotions/update/$promotionId'
      path: '/promotions/update/$promotionId'
      fullPath: '/promotions/update/$promotionId'
      preLoaderRoute: typeof AuthenticatedPromotionsUpdatePromotionIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/update/$productId': {
      id: '/_authenticated/products/update/$productId'
      path: '/products/update/$productId'
      fullPath: '/products/update/$productId'
      preLoaderRoute: typeof AuthenticatedProductsUpdateProductIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/guides/create/': {
      id: '/_authenticated/products/guides/create/'
      path: '/products/guides/create'
      fullPath: '/products/guides/create'
      preLoaderRoute: typeof AuthenticatedProductsGuidesCreateIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/products/guides/update/$guideId': {
      id: '/_authenticated/products/guides/update/$guideId'
      path: '/products/guides/update/$guideId'
      fullPath: '/products/guides/update/$guideId'
      preLoaderRoute: typeof AuthenticatedProductsGuidesUpdateGuideIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedActivityIndexRoute: typeof AuthenticatedActivityIndexRoute
  AuthenticatedApisIndexRoute: typeof AuthenticatedApisIndexRoute
  AuthenticatedLanguagesIndexRoute: typeof AuthenticatedLanguagesIndexRoute
  AuthenticatedNotificationsIndexRoute: typeof AuthenticatedNotificationsIndexRoute
  AuthenticatedProductsIndexRoute: typeof AuthenticatedProductsIndexRoute
  AuthenticatedPromotionsIndexRoute: typeof AuthenticatedPromotionsIndexRoute
  AuthenticatedSecurityIndexRoute: typeof AuthenticatedSecurityIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedTrafficIndexRoute: typeof AuthenticatedTrafficIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedProductsUpdateProductIdRoute: typeof AuthenticatedProductsUpdateProductIdRoute
  AuthenticatedPromotionsUpdatePromotionIdRoute: typeof AuthenticatedPromotionsUpdatePromotionIdRoute
  AuthenticatedActivityBalanceChangesIndexRoute: typeof AuthenticatedActivityBalanceChangesIndexRoute
  AuthenticatedActivityDepositHistoryIndexRoute: typeof AuthenticatedActivityDepositHistoryIndexRoute
  AuthenticatedActivityLogsIndexRoute: typeof AuthenticatedActivityLogsIndexRoute
  AuthenticatedProductsCategoriesIndexRoute: typeof AuthenticatedProductsCategoriesIndexRoute
  AuthenticatedProductsCreateIndexRoute: typeof AuthenticatedProductsCreateIndexRoute
  AuthenticatedProductsGuidesIndexRoute: typeof AuthenticatedProductsGuidesIndexRoute
  AuthenticatedProductsOrdersIndexRoute: typeof AuthenticatedProductsOrdersIndexRoute
  AuthenticatedPromotionsCreateIndexRoute: typeof AuthenticatedPromotionsCreateIndexRoute
  AuthenticatedProductsGuidesUpdateGuideIdRoute: typeof AuthenticatedProductsGuidesUpdateGuideIdRoute
  AuthenticatedProductsGuidesCreateIndexRoute: typeof AuthenticatedProductsGuidesCreateIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedActivityIndexRoute: AuthenticatedActivityIndexRoute,
  AuthenticatedApisIndexRoute: AuthenticatedApisIndexRoute,
  AuthenticatedLanguagesIndexRoute: AuthenticatedLanguagesIndexRoute,
  AuthenticatedNotificationsIndexRoute: AuthenticatedNotificationsIndexRoute,
  AuthenticatedProductsIndexRoute: AuthenticatedProductsIndexRoute,
  AuthenticatedPromotionsIndexRoute: AuthenticatedPromotionsIndexRoute,
  AuthenticatedSecurityIndexRoute: AuthenticatedSecurityIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedTrafficIndexRoute: AuthenticatedTrafficIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedProductsUpdateProductIdRoute:
    AuthenticatedProductsUpdateProductIdRoute,
  AuthenticatedPromotionsUpdatePromotionIdRoute:
    AuthenticatedPromotionsUpdatePromotionIdRoute,
  AuthenticatedActivityBalanceChangesIndexRoute:
    AuthenticatedActivityBalanceChangesIndexRoute,
  AuthenticatedActivityDepositHistoryIndexRoute:
    AuthenticatedActivityDepositHistoryIndexRoute,
  AuthenticatedActivityLogsIndexRoute: AuthenticatedActivityLogsIndexRoute,
  AuthenticatedProductsCategoriesIndexRoute:
    AuthenticatedProductsCategoriesIndexRoute,
  AuthenticatedProductsCreateIndexRoute: AuthenticatedProductsCreateIndexRoute,
  AuthenticatedProductsGuidesIndexRoute: AuthenticatedProductsGuidesIndexRoute,
  AuthenticatedProductsOrdersIndexRoute: AuthenticatedProductsOrdersIndexRoute,
  AuthenticatedPromotionsCreateIndexRoute:
    AuthenticatedPromotionsCreateIndexRoute,
  AuthenticatedProductsGuidesUpdateGuideIdRoute:
    AuthenticatedProductsGuidesUpdateGuideIdRoute,
  AuthenticatedProductsGuidesCreateIndexRoute:
    AuthenticatedProductsGuidesCreateIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
